var _rect, _rect2, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "be",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 512,
    height: 512,
    fill: "#a2001d"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 361.739,
    height: 166.957,
    transform: "translate(150.261 345.043)",
    fill: "#6da544"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M19.478,461.52,47.3,411.828,75.13,461.52l27.826-49.692,27.826,49.692L102.96,512h47.3V0h-47.3l27.825,49.688-27.826,50.483L75.133,49.688,47.307,100.171,19.48,49.688,47.3,0H0V512H47.3Zm83.48-86.794L75.132,324.243,47.306,374.726,19.48,324.243l27.826-49.692,27.826,49.692,27.826-49.692,27.826,49.692ZM47.3,137.274,75.13,186.966l27.826-49.692,27.826,49.692-27.826,50.483L75.13,186.966,47.3,237.449,19.478,186.966Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M75.132,461.52,47.307,512h55.648Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M75.132,49.688,102.957,0H47.307Z",
    fill: "#f0f0f0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M130.784,186.966l-27.826-49.692L75.132,186.966l27.826,50.483Z",
    fill: "#a2001d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M47.3,237.449l27.828-50.483L47.3,137.274,19.478,186.966Z",
    fill: "#a2001d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M102.958,274.551,75.132,324.244l27.826,50.482,27.826-50.482Z",
    fill: "#a2001d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M19.478,324.244,47.3,374.726l27.828-50.482L47.3,274.551Z",
    fill: "#a2001d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M130.784,461.52l-27.826-49.692L75.132,461.52,102.955,512h0Z",
    fill: "#a2001d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M75.132,461.52,47.3,411.828,19.478,461.52,47.3,512h0Z",
    fill: "#a2001d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M75.132,49.688l27.826,50.484,27.826-50.484L102.96,0h0Z",
    fill: "#a2001d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M19.478,49.688,47.3,100.172,75.132,49.688,47.307,0h0Z",
    fill: "#a2001d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBe);
export default __webpack_public_path__ + "static/media/be.a4c7e211ebb57b8a3b6d85eac9d93b56.svg";
export { ForwardRef as ReactComponent };